module.exports = __webpack_public_path__ + "img/triangle-2.80acc510.png";